export default __webpack_public_path__ + "static/media/bg3.1f47eaa8.jpeg";